import {useEvent} from 'Event/EventProvider'
import {api} from 'lib/url'
import {
  ObieIntegration,
  UserRegistrationMode,
} from 'organization/Event/Services/Apps/Obie'
import {useServices} from 'organization/Event/Services/ServicesProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {useState} from 'react'

export interface UpdateData {
  obie_hub_id: string
  user_registration_mode: UserRegistrationMode
  obie_offer_id: string | null
}

export function useSave() {
  const {client} = useOrganization()
  const {event} = useEvent()
  const {update: updateIntegration} = useServices()
  const [isSaving, setIsSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const save = (data: UpdateData) => {
    setIsSaving(true)
    setError(null)

    client
      .put<ObieIntegration>(api(`/events/${event.id}/integrations/obie`), data)
      .then(updateIntegration)
      .catch((e) => setError(e.message))
      .finally(() => setIsSaving(false))
  }

  return {save, isSaving, error}
}
